import dayjs from 'dayjs';

// Types
import type { DatepickerGlobalStoreStateType } from '@/utils/zustand/stores/datepicker-global-store';

const datepickerGlobalLocalStorageKey = 'local-storage-datepicker-global';

export function setDatepickerGlobalLocalStorage(datepickerData: DatepickerGlobalStoreStateType) {
    window.localStorage.setItem(datepickerGlobalLocalStorageKey, JSON.stringify(datepickerData));
}

export function getDatepickerGlobalLocalStorage(): DatepickerGlobalStoreStateType {
    if (!window.localStorage.getItem(datepickerGlobalLocalStorageKey)) {
        return {
            date: { from: dayjs().toDate(), to: dayjs().toDate() },
            period: 'last_30_days',
            compareTo: 'previous_period'
        };
    }

    return JSON.parse(window.localStorage.getItem(datepickerGlobalLocalStorageKey));
}
